module.exports = __webpack_public_path__ + "b1d7f9a9affbed5e6e2203123bec5392.jpg";